import { render, staticRenderFns } from "./clickCollect.vue?vue&type=template&id=186724b1&scoped=true&"
import script from "./clickCollect.vue?vue&type=script&lang=js&"
export * from "./clickCollect.vue?vue&type=script&lang=js&"
import style0 from "./clickCollect.vue?vue&type=style&index=0&id=186724b1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186724b1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
